import React, { useState } from 'react';
import ProfessionalLedger from './ProfessionalLedger';
import PartyLedgerPage from './PartyLedgerPage';
import { BookOpen, Users } from 'lucide-react';

export default function LedgerDashboard() {
  const [activeTab, setActiveTab] = useState('account');

  return (
    <div data-testid="ledger-dashboard" className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading font-bold text-2xl tracking-tight text-slate-900 dark:text-slate-100">Ledger</h1>
          <p className="text-sm text-slate-500 mt-1">View account and party ledgers</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 bg-slate-100 dark:bg-slate-800 p-1 rounded-lg w-fit" data-testid="ledger-tabs">
        <button
          onClick={() => setActiveTab('account')}
          data-testid="tab-account-ledger"
          className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${
            activeTab === 'account'
              ? 'bg-white dark:bg-slate-700 text-purple-700 dark:text-purple-300 shadow-sm'
              : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
          }`}
        >
          <BookOpen className="w-4 h-4" />
          Account Ledger
        </button>
        <button
          onClick={() => setActiveTab('party')}
          data-testid="tab-party-ledger"
          className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${
            activeTab === 'party'
              ? 'bg-white dark:bg-slate-700 text-purple-700 dark:text-purple-300 shadow-sm'
              : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
          }`}
        >
          <Users className="w-4 h-4" />
          Party Ledger
        </button>
      </div>

      {/* Tab Content */}
      <div data-testid="ledger-tab-content">
        {activeTab === 'account' ? <ProfessionalLedger /> : <PartyLedgerPage />}
      </div>
    </div>
  );
}
